import { OpportunityCategory } from "@/opportunity/opportunity";

export const getCategoryColor = (category: string, categories: OpportunityCategory[]): string => {
    const colorPalette = [
        "bg-blue-500 text-white",
        "bg-yellow-500 text-black",
        "bg-gray-500 text-white",
        "bg-yellow-700 text-black",
        "bg-gray-200 text-black",
        "bg-yellow-200 text-black",
        "bg-sky-500 text-white",
    ];

    // Create a map to store category-color associations
    const categoryColorMap: Record<string, string> = {};

    // Assign colors to categories
    categories.forEach((cat, index) => {
        const colorIndex = index % colorPalette.length;
        categoryColorMap[cat.name] = colorPalette[colorIndex];
    });

    // Return the color for the given category, or a default color if not found
    return categoryColorMap[category] || "bg-gray-300 text-black";
};